import React, { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentWrapper from '../../ui/Content/Content';
import { Background, Note, Table, TableWrapper } from './RentParameters.elements';

interface RentParametersProps {}

const RentParametersTemplate: FC<RentParametersProps> = () => {
    const { t } = useTranslation();

    return (
        <Background>
            <ContentWrapper>
                <TitleTemplate tagType={TitleTagTypes.H3} isBlack>
                    {t('classroomRent.parameters.title')}
                </TitleTemplate>
                <TableWrapper>
                    <Table desktopWidth={1000}>
                        <tbody>
                            <tr>
                                <th></th>
                                <th style={{ width: '175px', paddingTop: '80px' }}>
                                    <span>{t('classroomRent.table.column1.label')}</span>
                                </th>
                                <th style={{ width: '175px' }}>
                                    <IconTemplate name={Icons.Capacity2} className="icon" />
                                    <span>{t('classroomRent.table.column2.label')}</span>
                                </th>
                                <th style={{ width: '175px' }}>
                                    <IconTemplate name={Icons.Capacity3} className="icon" />
                                    <span>{t('classroomRent.table.column3.label')}</span>
                                </th>
                                <th style={{ width: '175px' }}>
                                    <IconTemplate name={Icons.Capacity1} className="icon" />
                                    <span>{t('classroomRent.table.column4.label')}</span>
                                </th>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.table.row1.label')}</td>
                                <td>5,7 m x 7,6 m</td>
                                <td>až 24</td>
                                <td>až 12</td>
                                <td>až 28</td>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.table.row2.label')}</td>
                                <td>7,5 m x 9,8 m</td>
                                <td>až 48</td>
                                <td>až 16</td>
                                <td>až 56</td>
                            </tr>
                        </tbody>
                    </Table>
                </TableWrapper>
            </ContentWrapper>
            <ContentWrapper withPadding>
                <TitleTemplate tagType={TitleTagTypes.H3} isBlack>
                    {t('classroomRent.prices.title')}
                </TitleTemplate>
                <TableWrapper>
                    <Table desktopWidth={800} mobileWidth={650}>
                        <tbody>
                            <tr>
                                <th>
                                    <span>{t('classroomRent.prices.table1.row1.label')}</span>
                                </th>
                                <th style={{ width: '200px' }}>
                                    <span>Cena (bez DPH)</span>
                                </th>
                                <th style={{ width: '200px' }}>
                                    <span>Cena (bez DPH)</span>
                                </th>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table1.row2.label')}</td>
                                <td style={{ width: '200px' }}>2 000 Kč/hod</td>
                                <td style={{ width: '200px' }}>14 000 Kč/den*</td>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table1.row3.label')}</td>
                                <td style={{ width: '200px' }}>3 000 Kč/hod</td>
                                <td style={{ width: '200px' }}>20 000 Kč/den*</td>
                            </tr>
                        </tbody>
                    </Table>
                </TableWrapper>
                <Note>*{t('classroomRent.prices.table1.row2.note')}</Note>
                <TableWrapper>
                    <Table desktopWidth={800} mobileWidth={500}>
                        <tbody>
                            <tr>
                                <th>
                                    <span>{t('classroomRent.prices.table2.row1.label')}</span>
                                </th>
                                <th style={{ width: '200px' }}>
                                    <span>Cena (bez DPH)</span>
                                </th>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table2.row2.label')}</td>
                                <td style={{ width: '200px' }}>V ceně</td>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table2.row3.label')}</td>
                                <td style={{ width: '200px' }}>V ceně</td>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table2.row4.label')}</td>
                                <td style={{ width: '200px' }}>V ceně</td>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table2.row5.label')}</td>
                                <td style={{ width: '200px' }}>590 Kč/den</td>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table2.row6.label')}</td>
                                <td style={{ width: '200px' }}>1 000 Kč/den</td>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table2.row7.label')}</td>
                                <td style={{ width: '200px' }}>200 Kč</td>
                            </tr>
                        </tbody>
                    </Table>
                </TableWrapper>
                <TableWrapper>
                    <Table desktopWidth={800} mobileWidth={500}>
                        <tbody>
                            <tr>
                                <th>
                                    <span className="withoutBorder">{t('classroomRent.prices.table3.row1.label')}</span>
                                </th>
                            </tr>
                            <tr>
                                <td>{t('classroomRent.prices.table3.row1.description')}</td>
                            </tr>
                        </tbody>
                    </Table>
                </TableWrapper>
            </ContentWrapper>
        </Background>
    );
};
export default RentParametersTemplate;
